import ModalDetailsRow from "../../../../../components/ModalDetailsRow/ModalDetailsRow.component";

export default function DetailsTab({ user, onCloseModal, onLockUnlock }) {
  return (
    <form>
      <ModalDetailsRow
        label="Email"
        value={user?.email}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="First Name"
        value={user?.firstName ?? user?.first_name}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="Last Name"
        value={user?.lastName ?? user?.last_name}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="User Name"
        value={user?.userName ?? user?.username}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="User Type"
        value={user?.userType ?? user?.user_type}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="Phone Number"
        value={user?.phoneNumber ?? user?.phone}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="Date Joined"
        value={(user?.createdDate ?? user?.date_joined)?.substring(0, 10)}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="Last Login"
        value={
          (user?.lastLogin ?? user?.last_login)
            ? `${(user?.lastLogin ?? user?.last_login).substring(0, 10)} / ${(user?.lastLogin ?? user?.last_login).substring(11, 19)}`
            : "N/A"
        }
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="Locked Status"
        value={user?.isLocked ? "Locked" : "Unlocked"}
        icon="fas fa-lock"
      />

      <div className="Form__action-buttons m-t-1">
        <button
          type="button"
          className="btn zoom-element btn login-btn m-0 mr-auto"
          onClick={onLockUnlock}
        >
          <i className={`fas fa-${user?.isLocked ? "lock-open" : "lock"}`}></i>
          &nbsp; {user?.isLocked ? "Unlock User" : "Lock User"}
        </button>
        <button
          type="button"
          className="btn zoom-element btn login-btn m-0 ml-auto"
          onClick={onCloseModal}
          data-dismiss="modal"
        >
          <i className="fas fa-times-circle"></i>
          &nbsp; Close
        </button>
      </div>
    </form>
  );
}
